import { MessageChannel } from '@/services/messageChannel/messageChannel'
import { GW_BRIDGE_CHANNEL_NAME } from '@/config'
import type { MessagesFromGW, MessagesFromTab } from '@/Workers/Gateway/types'


export const gwBridge = new MessageChannel<MessagesFromGW, MessagesFromTab>(
  GW_BRIDGE_CHANNEL_NAME,
  window.contextId,
)
